"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Teller_1 = require("../../../../DriveScout/Billing/Teller");
var PaymentRequest_1 = require("../../../common/payments/PaymentRequest");
var AdminPaymentController = /** @class */ (function () {
    function AdminPaymentController($scope, $stateParams, PaymentModel, CreateOrderService, FlashService) {
        this.payment = null;
        this.refunds = [];
        this.loading = true;
        this.error = null;
        this.orderUuid = null;
        this.financialSummary = null;
        this.refundDecision = { valid: false };
        /** The refund's key, held across a retry of the same amount and lifecycle. */
        this.refundRequest = new PaymentRequest_1.PaymentRequest();
        // Refund form
        this.refundAmount = null;
        this.refundLast4 = "";
        this.refundExpirationMonth = "";
        this.refundExpirationYear = "";
        this.processingRefund = false;
        this.refundError = null;
        this.refundSuccess = false;
        this.gateway = "";
        // Void
        this.processingVoid = false;
        this.voidError = null;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.PaymentModel = PaymentModel;
        this.CreateOrderService = CreateOrderService;
        this.FlashService = FlashService;
        var cashier = this.CreateOrderService.cashier();
        this.gateway = cashier
            .policies()
            .getPolicyByName("billing")
            .getMetaValueByKey("billing_gateway");
        this.setRefundDecision = this.setRefundDecision.bind(this);
        this.loadPayment();
    }
    AdminPaymentController.prototype.loadPayment = function () {
        var _this = this;
        this.loading = true;
        this.error = null;
        this.PaymentModel.show(this.$stateParams.paymentId)
            .then(function (response) {
            _this.payment = response.payment;
            _this.refunds = response.refunds;
            _this.financialSummary = response.financial_summary || null;
            _this.orderUuid = response.order_uuid || null;
            _this.refundLast4 = response.payment.card_last_4 || _this.refundLast4;
            _this.loading = false;
        })
            .catch(function (error) {
            _this.error = "Failed to load payment details";
            _this.loading = false;
            console.error("Error loading payment:", error);
        });
    };
    AdminPaymentController.prototype.setRefundDecision = function (decision) {
        var _this = this;
        this.$scope.$evalAsync(function () {
            _this.refundDecision = decision;
        });
    };
    AdminPaymentController.prototype.canVoid = function () {
        return (this.payment !== null &&
            !this.payment.void &&
            (!this.financialSummary ||
                (this.refunds.length === 0 &&
                    !this.financialSummary.reconciliation_required)));
    };
    AdminPaymentController.prototype.canRefund = function () {
        return (this.payment !== null &&
            !this.payment.void &&
            (!this.financialSummary ||
                (this.refundDecision.valid && this.payment.status === "succeeded")));
    };
    AdminPaymentController.prototype.voidPayment = function () {
        var _this = this;
        if (!this.canVoid()) {
            return;
        }
        if (!confirm("Are you sure you want to void this payment? This action cannot be undone.")) {
            return;
        }
        this.processingVoid = true;
        this.voidError = null;
        this.PaymentModel.voidPayment(this.payment.id.toString())
            .then(function (response) {
            _this.loadPayment();
            _this.processingVoid = false;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        })
            .catch(function (error) {
            var _a;
            _this.voidError = ((_a = error.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to void payment";
            _this.processingVoid = false;
        });
    };
    AdminPaymentController.prototype.isAuthorizeGateway = function () {
        return this.gateway === "authorize";
    };
    /**
     * Convert amount from cents to formatted dollar string
     */
    AdminPaymentController.prototype.formatAmount = function (amountInCents) {
        return (0, Teller_1.inDollars)(amountInCents);
    };
    /**
     * Get the maximum refund amount in dollars for form validation
     */
    AdminPaymentController.prototype.getMaxRefundAmount = function () {
        return this.payment
            ? Math.max(0, this.payment.amount -
                this.refunds.reduce(function (sum, refund) { return sum + refund.amount; }, 0)) / 100
            : 0;
    };
    AdminPaymentController.prototype.validateRefundForm = function () {
        if (!this.payment || !this.refundAmount) {
            return false;
        }
        var maxRefundAmount = this.getMaxRefundAmount();
        if (this.refundAmount <= 0 || this.refundAmount > maxRefundAmount) {
            return false;
        }
        if (this.isAuthorizeGateway() && this.payment.payment_method === "card") {
            if (!this.refundLast4 || this.refundLast4.length !== 4) {
                return false;
            }
            if (!this.financialSummary &&
                (!this.refundExpirationMonth || !this.refundExpirationYear)) {
                return false;
            }
        }
        return true;
    };
    AdminPaymentController.prototype.processRefund = function () {
        var _this = this;
        if (!this.validateRefundForm() || !this.payment || !this.canRefund()) {
            return;
        }
        this.processingRefund = true;
        this.refundError = null;
        this.refundSuccess = false;
        var expirationDate = null;
        if (this.isAuthorizeGateway() &&
            this.refundExpirationMonth &&
            this.refundExpirationYear) {
            expirationDate = "".concat(this.refundExpirationMonth, "/").concat(this.refundExpirationYear);
        }
        // Convert refund amount from dollars to cents for API call
        var refundAmountInCents = Math.round(this.refundAmount * 100);
        var lifecycle = this.financialSummary
            ? __assign({ purpose: this.refundDecision.purpose }, (this.refundDecision.cancel_order !== undefined
                ? { cancel_order: this.refundDecision.cancel_order }
                : {})) : {};
        // The API's refund replay compares the amount and the lifecycle, so they
        // are the details; last4 and the expiry are sent as typed.
        var refundOptions = this.refundRequest.bodyFor(__assign({ payment_id: this.payment.id, amount: refundAmountInCents }, lifecycle), function (requestId) { return (__assign(__assign({}, lifecycle), { request_id: requestId })); });
        this.PaymentModel.refundPayment(this.payment.user_id, this.payment.id, refundAmountInCents, this.isAuthorizeGateway() ? this.refundLast4 : null, expirationDate, this.isAuthorizeGateway() ? this.refundExpirationMonth : null, this.isAuthorizeGateway() ? this.refundExpirationYear : null, refundOptions)
            .then(function (response) {
            _this.refundRequest.settled(PaymentRequest_1.PaymentOutcome.answered(response));
            _this.processingRefund = false;
            _this.refundSuccess = true;
            _this.refundAmount = null;
            _this.refundLast4 = "";
            _this.refundExpirationMonth = "";
            _this.refundExpirationYear = "";
            _this.FlashService.setMessage({
                type: "success",
                message: "Refund of ".concat(_this.formatAmount(refundAmountInCents), " processed successfully"),
            });
            _this.payment = response.payment; // Reload payment to get updated status
            _this.loadPayment();
        })
            .catch(function (error) {
            var _a;
            _this.refundRequest.settled(PaymentRequest_1.PaymentOutcome.failed(error));
            _this.refundError = ((_a = error.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to process refund"; // DS-PORT-DEFECT (drivescout-vue3 M4 slice 3, 2026-10-07): row F-refund-inline-error: no error envelope on this route carries a top-level message (a DriveCoachException answers {id, status, title, detail}, a ValidationException the same plus errors, Handler.php:133-147), so the inline box (payment.html:255-257) always reads "Failed to process refund", while the interceptor flashes the API's detail for a 400, 409 or 422 (auth-interceptor.service.js:50-97); fixed in the port (the inline box holds the API's sentence).
            _this.loadPayment();
            _this.processingRefund = false;
        });
    };
    return AdminPaymentController;
}());
AdminPaymentController.$inject = [
    "$scope",
    "$stateParams",
    "PaymentModel",
    "CreateOrderService",
    "FlashService",
];
exports.default = AdminPaymentController;
